import { defineComponent as g, toRef as c, useTemplateRef as C, computed as r, openBlock as n, createBlock as a, mergeProps as d, withCtx as B, createCommentVNode as i, unref as o, renderSlot as I, createElementBlock as k, toDisplayString as z } from "vue";
import { AdsIcon as f } from "../icon/index.js";
import { AdsLoading as P } from "../loading/index.js";
import { _ as $ } from "../../chunks/index.99cfd0be.js";
import { u as m } from "../../chunks/useIconProps.ee768c90.js";
import './index.css';const x = ["textContent"], S = /* @__PURE__ */ g({
  name: "AdsButton",
  __name: "index",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" },
    type: { default: "button" },
    text: {},
    prependIcon: {},
    appendIcon: {},
    disabled: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    variation: { default: "primary" },
    iconOnly: {},
    size: { default: "default" }
  },
  setup(t, { expose: y }) {
    const { iconProps: l } = m(
      c(() => t.prependIcon),
      { size: 18 }
    ), { iconProps: u } = m(
      c(() => t.appendIcon),
      { size: 18 }
    ), p = C("ads-button"), v = r(() => [
      "ads-button",
      t.variation && `ads-button--${t.variation}`,
      `ads-button--size-${t.size}`,
      t.isLoading && "ads-button--loading",
      t.iconOnly && "ads-button--icon-only"
    ]), b = r(() => ({
      primary: "inverse",
      "primary-inverse": "inverse",
      secondary: "inherit",
      "secondary-inverse": "inherit",
      tertiary: "inherit",
      "tertiary-inverse": "inverse",
      destructive: "inverse",
      "destructive-inverse": "inherit",
      "destructive-secondary": "inherit",
      none: "default"
    })[t.variation] || "default"), h = r(() => {
      const e = {};
      return t.disabled && (t.as !== "button" && (e["aria-disabled"] = !0), e.disabled = !0), t.type && (e.type = t.type), e;
    });
    return y({
      focus: (e) => {
        var s;
        (s = p.value) == null || s.focus(e);
      }
    }), (e, s) => (n(), a($, d({
      ...h.value,
      as: e.as,
      asChild: e.asChild
    }, {
      ref: "ads-button",
      class: v.value,
      "data-focus-tabbed": ""
    }), {
      default: B(() => [
        e.isLoading ? (n(), a(P, {
          key: 0,
          class: "ads-button__loading",
          variation: b.value,
          size: e.iconOnly ? "small" : "default"
        }, null, 8, ["variation", "size"])) : i("", !0),
        o(l) ? (n(), a(f, d({
          key: 1,
          class: "ads-button__icon"
        }, o(l)), null, 16)) : i("", !0),
        I(e.$slots, "default", {}, () => [
          e.text && !e.iconOnly ? (n(), k("span", {
            key: 0,
            class: "ads-button__label",
            textContent: z(e.text)
          }, null, 8, x)) : i("", !0)
        ]),
        o(u) ? (n(), a(f, d({
          key: 2,
          class: "ads-button__icon"
        }, o(u)), null, 16)) : i("", !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  S as AdsButton
};
